import React from "react";
import PropTypes from "prop-types";
import "./partner-container.m.css";

export const Partner = ({
  type,
  imageSrc,
  imageClassName,
  logoClassName,
  containerClassName = "partner-item",
  hyperLink,
}) => {
  return (
    <article styleName={containerClassName}>
      <p styleName="partner-type">{type}</p>
      {imageSrc ? (
        hyperLink ? (
          <a href={hyperLink} target="_blank" rel="nofollow">
            <img src={imageSrc} alt={`${type} logo`} styleName={imageClassName} />
          </a>
        ) : (
          <img src={imageSrc} alt={`${type} logo`} styleName={imageClassName} />
        )
      ) : (
        <div styleName={logoClassName} role="img" aria-label={`${type} logo`} />
      )}
    </article>
  );
};

Partner.propTypes = {
  type: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  hyperLink: PropTypes.string,
  imageClassName: PropTypes.string,
  logoClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};
